// src/store/slices/empresasSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import EmpresaService from 'services/EmpresaService';

export const fetchEmpresas = createAsyncThunk(
    'empresas/fetchAll',
    async (params, { rejectWithValue }) => {
        try {
            return await EmpresaService.getAll({ paginate: 1, ...params });
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error al cargar empresas');
        }
    }
);

export const createEmpresa = createAsyncThunk(
    'empresas/create',
    async (data, { rejectWithValue }) => {
        try {
            return await EmpresaService.create(data);
        } catch (err) {
            return rejectWithValue(err.response?.data?.errors || err.response?.data?.message);
        }
    }
);

export const updateEmpresa = createAsyncThunk(
    'empresas/update',
    async ({ id, data }, { rejectWithValue }) => {
        try {
            return await EmpresaService.update(id, data);
        } catch (err) {
            return rejectWithValue(err.response?.data?.errors || err.response?.data?.message);
        }
    }
);

export const deleteEmpresa = createAsyncThunk(
    'empresas/delete',
    async (id, { rejectWithValue }) => {
        try {
            await EmpresaService.remove(id);
            return id;
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error al eliminar');
        }
    }
);

export const updateEmpresaEstado = createAsyncThunk(
    'empresas/updateEstado',
    async ({ id, activa }, { rejectWithValue }) => {
        try {
            return await EmpresaService.updateEstado(id, activa);
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error al actualizar estado');
        }
    }
);

export const uploadEmpresaLogo = createAsyncThunk(
    'empresas/uploadLogo',
    async ({ id, file }, { rejectWithValue }) => {
        try {
            return await EmpresaService.uploadLogo(id, file);
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error al subir el logo');
        }
    }
);

const empresasSlice = createSlice({
    name: 'empresas',
    initialState: {
        list: [],
        pagination: { current: 1, pageSize: 15, total: 0 },
        loading: false,
        error: null,
    },
    reducers: {
        clearEmpresasError: (state) => { state.error = null; },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchEmpresas.pending, (state) => { state.loading = true; state.error = null; })
            .addCase(fetchEmpresas.fulfilled, (state, action) => {
                state.loading = false;
                state.list = action.payload.data;
                state.pagination = {
                    current: action.payload.meta.current_page,
                    pageSize: action.payload.meta.per_page,
                    total: action.payload.meta.total,
                };
            })
            .addCase(fetchEmpresas.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(createEmpresa.fulfilled, (state) => { state.loading = false; })
            .addCase(updateEmpresa.fulfilled, (state) => { state.loading = false; })
            .addCase(deleteEmpresa.fulfilled, (state, action) => {
                state.list = state.list.filter((e) => e.id !== action.payload);
            })
            .addCase(updateEmpresaEstado.fulfilled, (state, action) => {
                const updated = action.payload.empresa;
                if (updated) {
                    state.list = state.list.map((e) => (e.id === updated.id ? updated : e));
                }
            })
            .addCase(uploadEmpresaLogo.fulfilled, (state, action) => {
                const updated = action.payload.empresa;
                if (updated) {
                    state.list = state.list.map((e) => (e.id === updated.id ? updated : e));
                }
            });
    },
});

export const { clearEmpresasError } = empresasSlice.actions;
export default empresasSlice.reducer;